import { Redirect, RouteComponentProps } from "react-router-dom";
import { currentKarkhanaAddress, LEGACY_REDIRECTS } from "../pages/karkhana/karkhanaPaths";

/** An old Karkhana address: replace it (not push) with the new one, keeping the id, query and hash. */
export const KarkhanaLegacyRedirect = ({ location }: RouteComponentProps) => (
  <Redirect to={currentKarkhanaAddress(`${location.pathname}${location.search}${location.hash}`)} />
);

/** Rendered before every other route (App.tsx), so old links never reach a guard or a page. */
export const karkhanaLegacyRoutes = LEGACY_REDIRECTS.map(([from]) => ({ path: from, exact: true, component: KarkhanaLegacyRedirect }));
